// extracted by mini-css-extract-plugin
export default {"checkIcon":"import_success_page-module___checkIcon___cbc0a2f3","title":"import_success_page-module___title___dece27ab"};